export const parseAdditionalDataProps = (
  additionalDataPropsStr: string
): { key: string; value: string }[] => {
  if (!additionalDataPropsStr) return [];

  return additionalDataPropsStr.split(';').map((prop) => {
    const [name, value] = prop
      .split(',')
      .map((part) => part.split('=').map((s) => s.trim()));
    return { key: name[1], value: value ? value[1] : '' };
  });
};
